
    $(document).ready(function() {

     $(document).on('change', '#Newoptions', function() {
    console.log("Selected>>");
    var selectedValue = $(this).val();
       $(this).parents('.buttonsWrapper').find('.form [name="id"]').attr('value',selectedValue);
    console.log("Selected value>>", selectedValue);
  });
    });
    
  document.addEventListener("DOMContentLoaded", function () {
    const variantSelects = document.querySelectorAll(".variant-select");
    variantSelects.forEach(function (select) {
      select.addEventListener("change", function () {
        const wrapper = select.closest(".buttonsWrapper");
        const selectedOption = select.options[select.selectedIndex];
        const available = selectedOption.getAttribute("data-available") === "true";
        const variantId = selectedOption.value;
        //console.log(variantId);
       // alert('hello')
        const hiddenInput = wrapper.querySelector(".variant-id");
        const addToCartBtn = wrapper.querySelector(".add-to-cart-button");
        const soldOutMessage = addToCartBtn.querySelector(".sold-out-message");
        const btnText = addToCartBtn.querySelector(".btn-text");

        // Update hidden input with selected variant ID
        hiddenInput.value = variantId;

        if (!available) {
          addToCartBtn.setAttribute("disabled", "disabled");
          soldOutMessage.classList.remove("hidden");
          btnText.textContent = soldOutMessage.textContent;
        } else {
          addToCartBtn.removeAttribute("disabled");
          soldOutMessage.classList.add("hidden");
          btnText.textContent = "Add to cart";
        }
      });
    });
  });
